import {RsnDialog} from '@raison/ui-kit';
import React, {ComponentProps, ReactNode} from 'react';

export interface WrapperPropsInterface {
    title: string;
    children: ReactNode;
    padding?: ComponentProps<typeof RsnDialog.Body>['padding'];
    footer?: ReactNode;
}

export const FilterPopupLayout = ({title, children, footer, padding = 'full'}: WrapperPropsInterface) => {
    return (
        <RsnDialog.Window placement='bottom'>
            <RsnDialog.LeftHeader>{title}</RsnDialog.LeftHeader>
            <RsnDialog.Body padding={padding}>{children}</RsnDialog.Body>
            {!!footer && <RsnDialog.Footer floating>{footer}</RsnDialog.Footer>}
        </RsnDialog.Window>
    );
};
